/**
 * Takes attachments and returns a menu content object for the given floor
 * id_location : the id_location to get assets for
 * data_attachments : {id_location:{id_attachment_1:{}, id_attachment_2:{}}}
 * returns a simple object contining the number of attachments: { count: 123 }
 */
export function build_menu_content(floor_attachments: any)
{
    var attachment_count = 0;
    if (floor_attachments !== undefined) {
        if (floor_attachments !== null) {
            attachment_count  = _.keys(floor_attachments).length;
        }
    }
                
    return { count: attachment_count };


}
